import { Stack, Text } from '@mantine/core';
import TampilanControls from '@components/settings/TampilanControls';
import { useTheme } from '@contexts/ThemeContext';
import { useLanguage } from '@contexts/LanguageContext';
import { ONBOARDING_MODAL_Z_INDEX } from '../constants';
import { resolveFirstLoginCopy } from '../i18n';

/** Step 0: theme, language, text size. Applies immediately; nothing to save on Next. */
export default function StepTampilan() {
  const { colors: themeColors } = useTheme();
  const { language } = useLanguage();
  const t = (key: string) => resolveFirstLoginCopy(language, key);

  return (
    <Stack gap="md">
      <div>
        <Text component="h3" fw={700} style={{ color: themeColors.text, fontSize: 22, margin: 0, lineHeight: 1.2 }}>
          {t('tampilan.heading')}
        </Text>
        <Text size="sm" style={{ color: themeColors.textSecondary, marginTop: 6 }}>
          {t('tampilan.lead')}
        </Text>
      </div>
      <TampilanControls stacked dropdownZIndex={ONBOARDING_MODAL_Z_INDEX + 1} />
    </Stack>
  );
}
